import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { HypotheticalDateQuarter } from "gen/model/hypotheticalDateQuarter";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonOrder } from "shared/components/button/ButtonOrder";
import { FormCancelButton } from "shared/components/button/FormCancelButton";
import { FormSubmitButton } from "shared/components/button/FormSubmitButton";
import Form from "shared/components/form/Form";
import { SelectOption } from "shared/components/input/select/SelectOption";
import { SimpleSelect } from "shared/components/input/select/SimpleSelect";

interface QuarterSelectModalProps {
  allDateQuarters: HypotheticalDateQuarter[];
  selectedDateQuarter: HypotheticalDateQuarter;
  onSelectedDateQuarter: (selectedDateQuarter: HypotheticalDateQuarter) => void;
  onCloseComplete: () => void;
  onChangeSuccess: (date: string) => void;
}

const QuarterSelectModal: React.FC<QuarterSelectModalProps> = ({
  allDateQuarters,
  selectedDateQuarter,
  onSelectedDateQuarter,
  onCloseComplete,
  onChangeSuccess,
}) => {
  const { t } = useTranslation(["common"]);
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  const [selectedEffectiveDate, setEffectiveDate] = useState<string>(
    selectedDateQuarter.effective_date,
  );

  const onSubmit = () => {
    const dateQuarter = allDateQuarters.find(
      (dateQuarter) => dateQuarter.effective_date === selectedEffectiveDate,
    );
    onSelectedDateQuarter(dateQuarter!);
    onChangeSuccess(selectedEffectiveDate);
  };
  const form = useForm();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onCloseComplete={onCloseComplete}
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>View Performance as of</ModalHeader>
        <Form form={form} onSubmit={onSubmit} onSuccess={onCloseComplete}>
          <ModalBody>
            <SimpleSelect
              title={t("common:quarter")}
              value={selectedEffectiveDate}
              onChangeValue={(value) => {
                setEffectiveDate(value);
              }}
            >
              {allDateQuarters.map((dateQuarter) => (
                <SelectOption
                  key={dateQuarter.effective_date}
                  value={dateQuarter.effective_date}
                >
                  {dateQuarter.period_rich_value}
                </SelectOption>
              ))}
            </SimpleSelect>
          </ModalBody>
          <ModalFooter gap={2}>
            <ButtonOrder
              dismiss={
                <FormCancelButton onClick={onCloseComplete} autoFocus={true} />
              }
              confirm={
                <FormSubmitButton>{t("common:saveDate")}</FormSubmitButton>
              }
            />
          </ModalFooter>
        </Form>
      </ModalContent>
    </Modal>
  );
};

export default QuarterSelectModal;
